


import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { getLocalStorageMenuItem, SARIconThemeColor, setMobileButttonBackColor, setMobileTextColor, setMobileBackColor, setMobileHighlightTextColor } from "../../../utility";

const PriceOptionsButtons = ({ handleSelected, prices, currency, isDesktop, isTablet }) => {
  const [options, setOptions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const array = prices.map((price) => ({
      id: price.id,
      name: price.name,
      price: price.price,
      old_price: price.old_price || "",
    }));

    setOptions(array);

    // Always call handleSelected with the first option when options change
    if (array.length > 0) {
      setSelectedIndex(0); // Reset to first option
      handleSelected(array[0]); // Call handleSelected with first option
    }
  }, [prices]);

  // Additional useEffect to handle initial selection
  useEffect(() => {
    // This ensures that when the component mounts with existing options,
    // the first one is selected
    if (options.length > 0 && selectedIndex === 0) {
      handleSelected(options[0]);
    }
  }, [options, selectedIndex]);

  const handleOptionClick = (option, index) => {
    setSelectedIndex(index);
    handleSelected(option);
  };

  const isRTL = getLocalStorageMenuItem("lang") === "ar" || getLocalStorageMenuItem("lang") === "fa";

  return (
    <Box
      className="alignByLang"
      sx={{
        display: "flex",
        gap: isDesktop ? 2 : 0.2,
        marginTop: 2,
        width: "100%",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {options.map((option, index) => {
        const isSelected = selectedIndex === index;

        return (
          <Box
            key={option.id}
            onClick={() => handleOptionClick(option, index)}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: isDesktop ? "16px 20px" : "4px 8px",
              borderRadius: "12px",
              border: `2px solid ${isSelected ? setMobileButttonBackColor() : "rgba(107, 165, 242, 0.3)"}`,
              backgroundColor: isSelected
                ? setMobileButttonBackColor()
                : setMobileBackColor(),
              cursor: "pointer",
              transition: "all 0.3s ease",
              minWidth: isDesktop ? "140px" : "110px",
              flex: options.length === 2 ? "1 1 calc(50% - 12px)" : "0 1 auto",
              maxWidth: options.length === 2 ? "calc(50% - 12px)" : "none",
              "&:hover": {
                borderColor: setMobileButttonBackColor(),
                backgroundColor: isSelected
                  ? setMobileButttonBackColor()
                  : `${setMobileButttonBackColor()}15`,
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(107, 165, 242, 0.2)",
              },
            }}
          >
            {/* Radio Circle */}
            <Box
              sx={{
                width: isDesktop ? "20px" : "18px",
                height: isDesktop ? "20px" : "18px",
                borderRadius: "50%",
                border: `2px solid ${isSelected ? setMobileHighlightTextColor() || setMobileButttonBackColor() : setMobileButttonBackColor()}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                marginBottom: 1,
              }}
            >
              {isSelected && (
                <Box
                  sx={{
                    width: isDesktop ? "10px" : "8px",
                    height: isDesktop ? "10px" : "8px",
                    borderRadius: "50%",
                    backgroundColor: setMobileHighlightTextColor() || setMobileTextColor(),
                  }}
                />
              )}
            </Box>

            {/* Option Name */}
            <span
              style={{
                fontSize: isDesktop ? "15px" : "14px",
                fontWeight: isSelected ? 600 : 'bold',
                color: isSelected ? setMobileHighlightTextColor() || setMobileTextColor() : setMobileTextColor(),
                marginBottom: "6px",
                textAlign: "center",
              }}
            >
              {option.name}
            </span>

            {/* Price */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                flexDirection: "column",
              }}
            >
              {option.old_price && (
                <span
                  style={{
                    textDecoration: "line-through",
                    color: isSelected ? setMobileHighlightTextColor() || setMobileTextColor() : "red",
                    fontSize: isDesktop ? "12px" : "11px",
                  }}
                >
                  {option.old_price}
                </span>
              )}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <span
                  style={{
                    fontSize: isDesktop ? "18px" : "16px",
                    fontWeight: 600,
                    color: isSelected ? setMobileHighlightTextColor() || setMobileTextColor() : setMobileButttonBackColor(),
                  }}
                >
                  {option.price}
                </span>
                {currency && (
                  <span style={{ fontSize: isDesktop ? "14px" : "12px", color: isSelected ? setMobileHighlightTextColor() || setMobileTextColor() : setMobileTextColor() }}>
                    {currency === "SAR" ? (
                      <img
                        width={isDesktop ? 16 : 14}
                        height={isDesktop ? 16 : 14}
                        src={isSelected ? SARIconThemeColor(true) : SARIconThemeColor()}
                        alt="SAR"
                        style={{ verticalAlign: "middle" }}
                      />
                    ) : (
                      currency
                    )}
                  </span>
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default PriceOptionsButtons;